import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=67d13133&scoped=true&"
import script from "./ScrollUpButton.vue?vue&type=script&lang=ts&"
export * from "./ScrollUpButton.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=67d13133&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d13133",
  null
  
)

export default component.exports